export default __webpack_public_path__ + "static/media/underline-icon.85623501.svg";